import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    notification: [],
    autoRemove: false,
    status: 'idle',
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        addNotif(state, action) {
            // millisecond id
            let id = new Date().getTime();

            const addArr = {
                id: id,
                open: true,
                autoHideDuration: action.payload.autoHideDuration,
                severity: action.payload.severity,
                description: action.payload.description,
            };
            state.notification.push(addArr);
        },

        removeNotif(state, action) {
            state.notification = state.notification.filter(
                e => e.id !== action.payload.id
            );
        },
    },
});

export const { addNotif, removeNotif } = notificationSlice.actions;

export default notificationSlice.reducer;

export const getNotification = state => state.notification;
